<template>
	<div>
		<modal :width="440"
		       height="auto"
		       @before-close="$emit('before-close')"
		       name="m-search-alert">
			<div class="modal-dialog abtg-modal-dialog abtg-modal-small"
			     role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title abtg__modal-title mt-0">
							Limite
							<span v-if="isZoneUpdateAlert">aggiornamenti zona</span>
							<span v-else>ricerche</span> raggiunto
						</h5>

						<div class="tools mt-0">
							<div class="abtg__close-button"
							     style="margin-top: -12px;margin-right: -15px">
								<a @click="closeModal()">
									<i class="fas fa-times"></i>
								</a>
							</div>
						</div>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-12"
							     style="color: black">
								<div v-if="!isZoneUpdateAlert">
									Hai raggiunto il limite mensile di ricerche annunci.<br> Puoi attendere fino al 1° del mese successivo<br> oppure acquistare uno dei seguenti pacchetti<br>
									<br>
									<button @click="go(2000)"
									        class="btn abtg__default-button full-width abtg__btn-star mb-0">
										Pack + 2000 annunci - €50 + iva
									</button>
									<br>
									<button @click="go(3000)"
									        class="btn abtg__default-button full-width  abtg__btn-star mb-0 mt-2">
										Pack + 3000 annunci - €70 + iva
									</button>
									<br>
									<button @click="go(5000)"
									        class="btn abtg__default-button full-width abtg__btn-star mb-0 mt-2">
										Pack + 5000 annunci - €90 + iva
									</button>
								</div>

								<div v-if="isZoneUpdateAlert">
									Questa zona può essere aggiornata n.5 volte al mese (non influisce sul conteggio totale degli annunci).
									<br> I prossimi 5 aggiornamenti - per questa zona - saranno possibili il mese prossimo.
									<br> Puoi comunque aggiornare altre zone.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>

</template>
<script>
	export default {
		props: ['content', 'isZoneUpdateAlert'],
		data() {
			return {
				rangeData: {},
			}
		},

		methods: {
			closeModal: function() {
				this.$emit('closeModal')
			},
			go(number) {
				switch (number) {
					case 2000:
						window.location.href = 'https://formazione.alfiobardolla.com/carrello/?add-to-cart=223739'
						break

					case 3000:
						window.location.href = 'https://formazione.alfiobardolla.com/carrello/?add-to-cart=223747'
						break

					case 5000:
						window.location.href = 'https://formazione.alfiobardolla.com/carrello/?add-to-cart=223755'
						break
				}
			},
		},
	}
</script>